export default "__VITE_ASSET__Dr0ZeX2G__"